"use client";

import { useOrganizationList, useOrganization, useAuth } from "@/auth/hooks/clerk-hooks";
import { useEffect, useRef } from "react";

export default function OrganizationAutoSelector() {
    const { isSignedIn } = useAuth();
    const { isLoaded, setActive, userMemberships } = useOrganizationList({
        userMemberships: true,
    });

    const { organization } = useOrganization();
    const has_set_organization = useRef(false);

    useEffect(() => {
        if (!isSignedIn) return;

        if (
            isLoaded &&
            userMemberships.data &&
            userMemberships.data.length > 0 &&
            !has_set_organization.current &&
            !organization
        ) {
            try {
                const first_membership = userMemberships.data[0];
                setActive({ organization: first_membership.organization.id });

                has_set_organization.current = true;
            } catch (error) {
                console.error("Error setting active organization:", error);
            }
        }
    }, [isSignedIn, isLoaded, userMemberships.data, setActive, organization]);

    return null;
} 